<template>
  <modal
    :value="value"
    max-width="800"
    title="Videos"
    content-class="video-upload-modal"
    @input="emitInput"
  >
    <template #header>
      <div class="header-container">
        <div class="actions-section">
          <app-search ref="searchBar" @enter="handleSearch" />
          <div class="refresh-and-new-upload-wrapper">
            <button>
              <i
                v-tooltip="'Atualizar lista'"
                class="mdi mdi-refresh"
                @click="reload"
              ></i>
            </button>
            <video-new-upload-modal @on-upload="reload">
            </video-new-upload-modal>
          </div>
        </div>
      </div>
    </template>
    <div class="content-container flex-col">
      <v-radio-group v-model="selectedVideoId">
        <list
          :headers="headers"
          :list="videosList"
          :infiniteId="infiniteId"
          @load="load"
        >
          <template slot="default" slot-scope="slotProps">
            <video-list-item
              :item="slotProps.item"
              @on-deleted="reload"
              @on-selected="(val) => (selectedVideoId = val)"
            ></video-list-item>
          </template>
        </list>
      </v-radio-group>
    </div>
    <template #footer>
      <transition name="fade" mode="out-in" appear>
        <Button
          v-if="showContinueButton"
          class="btn-primary"
          label="Continuar"
          @click="emitSelectedVideo"
        />
      </transition>
    </template>
  </modal>
</template>

<script>
import Modal from "@/components/generic/Modal";
import List from "@components/generic/list/List.vue";
import Button from "@components/generic/button/Button.vue";
import VideoListItem from "./list/item/VideoListItem.vue";
import AppSearch from "@components/Search";
import VideoNewUploadModal from "./new-upload-modal/VideoNewUploadModal.vue";

export default {
  components: {
    Modal,
    List,
    Button,
    AppSearch,
    VideoListItem,
    VideoNewUploadModal,
  },
  data() {
    return {
      show: false,
      infiniteId: +new Date(),
      videosList: [],
      page: 0,
      search: "",
      selectedVideoId:
        this.type === "mobile"
          ? this.selectedVideoMobileId
          : this.selectedVideoDesktopId,
      selectedVideoName: undefined,
      selectedVideoUrl: undefined,
      showContinueButton: false,
    };
  },

  props: {
    type: {
      type: String,
      required: true,
    },
    value: {
      type: Boolean,
      default: false,
    },
    selectedVideoMobileId: {
      type: String,
    },
    selectedVideoDesktopId: {
      type: String,
    },
  },

  watch: {
    selectedVideoId(id) {
      this.showContinueButton = true;
      this.videosList.map((video) => {
        if (video.id === id) {
          this.selectedVideoName = video.name;
          this.selectedVideoUrl = video.videoUrl;
        }
      });
    },
  },

  computed: {
    headers() {
      return [
        {
          value: null,
          sortable: false,
        },
        {
          text: "Nome",
          value: "name",
          sortable: false,
        },
        {
          text: "Data de upload",
          value: "uploadDate",
          sortable: false,
        },
        {
          text: "Ações",
          value: "actions",
          sortable: false,
        },
      ];
    },
  },

  methods: {
    async load($state) {
      try {
        const { content, totalElements } = await this.$api.video.list({
          name: this.search,
          page: this.page,
        });

        if (content.length !== 0) {
          this.videosList.push(...content);
          this.page++;
          $state.loaded();

          if (this.videosList.length >= totalElements) {
            $state.complete();
          }
        } else {
          $state.complete();
        }
      } catch (error) {
        console.log(error);
        $state.complete();
      }
    },
    reload() {
      this.page = 0;
      this.videosList = [];
      this.search = "";
      this.infiniteId++;
    },
    closeModal() {
      this.emitInput(false);
    },
    emitInput(value) {
      this.$emit("input", value);
    },
    handleSearch(value) {
      this.page = 0;
      this.videosList = [];
      this.search = value;
      this.load();
    },
    emitSelectedVideo() {
      this.$emit("on-selected-video", {
        selectedVideoId: this.selectedVideoId,
        selectedVideoName: this.selectedVideoName,
        selectedVideoUrl: this.selectedVideoUrl,
        type: this.type,
      });
      this.closeModal();
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.video-upload-modal {
  .header-container {
    padding-bottom: 20px;
    .actions-section {
      display: flex;
      gap: 250px;

      .refresh-and-new-upload-wrapper {
        display: flex;
        align-items: center;
        gap: 24px;

        .mdi {
          font-size: 24px;
        }
      }
    }
  }

  .content-container {
    gap: 28px;

    ::v-deep .v-input__control {
      width: 100%;
    }

    ::v-deep .v-input--selection-controls {
      margin-top: 0;
      padding-top: 0;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    opacity: 1;
    transition: all 0.3s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
